// packages
import cx from 'classnames';
import { Component, h } from 'preact';

// components
import CandidateRow from './components/CandidateRow';
import Contest from './components/Contest';
import YourRaces from './components/YourRaces';
import Portal from './components/Portal';
import SeatPartyDivider from './components/SeatPartyDivider';
import Ad from './components/Ad';

import { determineContestTitle, chunk } from './election-utils';
import { FLAT_BALLOT_URL } from './endpoints';
import getJSON from './utils/get-json';

type State = {
  data: { [key: string]: any },
};

class App extends Component<{}, State> {
    constructor() {
      super();
  
      this.state = {
        data: [],
      };
  
      this.fetchData = this.fetchData.bind(this);
    }
  
    fetchData() {
      getJSON(FLAT_BALLOT_URL).then(data => this.setState({ data }));
    }
  
    componentDidMount() {
      this.fetchData();
    }
  
    componentWillUnmount() {}
  
    componentDidUpdate() {}
  
    render() {
      const { notes } = this.props;
      const { data } = this.state;
  
      const seats_mapped = data.map(number => ({
        office: number.office,
        office_slug: number.office_slug,
      }));
  
      function unique(array, propertyName) {
        return array.filter(
          (e, i) =>
            array.findIndex(a => a[propertyName] === e[propertyName]) === i
        );
      }
  
      let unique_seats = unique(seats_mapped, 'office_slug');
  
      // In order to sprinkle ads between races in sections where there a lot of races like the Texas House, we need to divide them into groups of nth races to make it into different divs
  
      const texasHouse = unique_seats.filter(
        contest => contest.office === 'Texas House'
      );
  
      const usHouse = unique_seats.filter(
        contest => contest.office === 'U.S. House'
      );
  
      let texasHouseGroups, usHouseGroups;
  
      if (texasHouse.length) {
        texasHouseGroups = chunk(texasHouse, 30);
        usHouseGroups = chunk(usHouse, 24);
      }
  
      return (
        <div class="ballot-list">
          <Portal
            node={document.getElementById('lookup-select')}
            ref={ref => (this._yourPortal = ref)}
          >
            <YourRaces contests={data} notes={notes} />
          </Portal>
  
          <Portal
            node={document.querySelector('#us-house .contests')}
            ref={ref => (this._usPortal = ref)}
          >
            <div class="office__contests">
              {usHouse.length > 0 &&
                usHouseGroups.map(contestGroup => (
                  <div class="contest-group">
                    <div class="seat__contests-double">
                      {contestGroup.map(contest => (
                        <Contest
                          key={contest.id}
                          contest={data.filter(
                            item => item.office_slug === contest.office_slug
                          )}
                          tableHeader={CandidateRow.Header}
                          columnCount={CandidateRow.columnCount}
                          notes={notes.filter(
                            item => item.type === contest.office_slug
                          )}          
                          contestTitle={determineContestTitle(
                            data.filter(
                              item => item.office_slug === contest.office_slug
                            )[0]
                          )}
                          renderParty={party => (
                            <SeatPartyDivider
                              partyName={party.party}
                              partyBallot={party}
                              tableHeader={CandidateRow.Header}
                              notes={notes.filter(
                                item =>
                                  item.type ===
                                  contest.office_slug + '-' + party.party
                              )}
                              columnCount={CandidateRow.columnCount}
                              renderCandidate={(candidate, idx) => (
                                <CandidateRow
                                  key={candidate.id}
                                  ballotName={candidate.name}
                                  candidateId={candidate.id}
                                  isIncumbent={candidate.is_incumbent}
                                  party={candidate.party}
                                />
                              )}
                            />
                          )}
                        />
                      ))}
                    </div>
                    <Ad />
                  </div>
                ))}
            </div>
          </Portal>
  
          <Portal
            node={document.querySelector('#governor .contests')}
            ref={ref => (this._supremePortal = ref)}
          >
            <div class="office__contests">
              {unique_seats
                .filter(contest => contest.office === 'Governor')
                .map(contest => (
                  <Contest
                    key={contest.id}
                    contest={data.filter(
                      item => item.office_slug === contest.office_slug
                    )}
                    notes={notes.filter(
                      item => item.type === contest.office_slug
                    )}
                    isShowcaseRace // These are big races that don't need headers because the headers are already in the text, we can just show the candidates
                    tableHeader={CandidateRow.Header}
                    columnCount={CandidateRow.columnCount}
                    contestTitle={determineContestTitle(
                      data.filter(
                        item => item.office_slug === contest.office_slug
                      )[0]
                    )}
                    renderParty={party => (
                      <SeatPartyDivider
                        partyName={party.party}
                        partyBallot={party}
                        tableHeader={CandidateRow.Header}
                        notes={notes.filter(
                          item =>
                            item.type === contest.office_slug + '-' + party.party
                        )}
                        columnCount={CandidateRow.columnCount}
                        renderCandidate={(candidate, idx) => (
                          <CandidateRow
                            key={candidate.id}
                            ballotName={candidate.name}
                            candidateId={candidate.id}
                            isIncumbent={candidate.is_incumbent}
                            party={candidate.party}
                          />
                        )}
                      />
                    )}
                  />
                ))}
            </div>
          </Portal>
          <Portal
            node={document.querySelector('#lieutenant-governor .contests')}
            ref={ref => (this._supremePortal = ref)}
          >
            <div class="office__contests">
              {unique_seats
                .filter(contest => contest.office === 'Lieutenant Governor')
                .map(contest => (
                  <Contest
                    key={contest.id}
                    contest={data.filter(
                      item => item.office_slug === contest.office_slug
                    )}
                    notes={notes.filter(
                      item => item.type === contest.office_slug
                    )}
                    isShowcaseRace
                    tableHeader={CandidateRow.Header}
                    columnCount={CandidateRow.columnCount}
                    contestTitle={determineContestTitle(
                      data.filter(
                        item => item.office_slug === contest.office_slug
                      )[0]
                    )}
                    renderParty={party => (
                      <SeatPartyDivider
                        partyName={party.party}
                        partyBallot={party}
                        tableHeader={CandidateRow.Header}
                        notes={notes.filter(
                          item =>
                            item.type === contest.office_slug + '-' + party.party
                        )}
                        columnCount={CandidateRow.columnCount}
                        renderCandidate={(candidate, idx) => (
                          <CandidateRow
                            key={candidate.id}
                            ballotName={candidate.name}
                            candidateId={candidate.id}
                            isIncumbent={candidate.is_incumbent}
                            party={candidate.party}
                          />
                        )}
                      />
                    )}
                  />
                ))}
            </div>
          </Portal>
          <Portal
            node={document.querySelector('#attorney-general .contests')}
            ref={ref => (this._supremePortal = ref)}
          >
            <div class="office__contests">
              {unique_seats
                .filter(contest => contest.office === 'Attorney General')
                .map(contest => (
                  <Contest
                    key={contest.id}
                    contest={data.filter(
                      item => item.office_slug === contest.office_slug
                    )}
                    notes={notes.filter(
                      item => item.type === contest.office_slug
                    )}
                    isShowcaseRace
                    tableHeader={CandidateRow.Header}
                    columnCount={CandidateRow.columnCount}
                    contestTitle={determineContestTitle(
                      data.filter(
                        item => item.office_slug === contest.office_slug
                      )[0]
                    )}
                    renderParty={party => (
                      <SeatPartyDivider
                        partyName={party.party}
                        partyBallot={party}
                        tableHeader={CandidateRow.Header}
                        notes={notes.filter(
                          item =>
                            item.type === contest.office_slug + '-' + party.party
                        )}
                        columnCount={CandidateRow.columnCount}
                        renderCandidate={(candidate, idx) => (
                          <CandidateRow
                            key={candidate.id}
                            ballotName={candidate.name}
                            candidateId={candidate.id}
                            isIncumbent={candidate.is_incumbent}
                            party={candidate.party}
                          />
                        )}
                      />
                    )}
                  />
                ))}
            </div>
          </Portal>
          <Portal
            node={document.querySelector('#land-commissioner .contests')}
            ref={ref => (this._supremePortal = ref)}
          >
            <div class="office__contests">
              {unique_seats
                .filter(contest => contest.office === 'Land Commissioner')
                .map(contest => (
                  <Contest
                    key={contest.id}
                    contest={data.filter(
                      item => item.office_slug === contest.office_slug
                    )}
                    notes={notes.filter(
                      item => item.type === contest.office_slug
                    )}
                    isShowcaseRace
                    tableHeader={CandidateRow.Header}
                    columnCount={CandidateRow.columnCount}
                    contestTitle={determineContestTitle(
                      data.filter(
                        item => item.office_slug === contest.office_slug
                      )[0]
                    )}
                    renderParty={party => (
                      <SeatPartyDivider
                        partyName={party.party}
                        partyBallot={party}
                        tableHeader={CandidateRow.Header}
                        notes={notes.filter(
                          item =>
                            item.type === contest.office_slug + '-' + party.party
                        )}
                        columnCount={CandidateRow.columnCount}
                        renderCandidate={(candidate, idx) => (
                          <CandidateRow
                            key={candidate.id}
                            ballotName={candidate.name}
                            candidateId={candidate.id}
                            isIncumbent={candidate.is_incumbent}
                            party={candidate.party}
                          />
                        )}
                      />
                    )}
                  />
                ))}
            </div>
          </Portal>
          <Portal
            node={document.querySelector('#comptroller .contests')}
            ref={ref => (this._supremePortal = ref)}
          >
            <div class="office__contests">
              {unique_seats
                .filter(contest => contest.office === 'Comptroller')
                .map(contest => (
                  <Contest
                    key={contest.id}
                    contest={data.filter(
                      item => item.office_slug === contest.office_slug
                    )}
                    notes={notes.filter(
                      item => item.type === contest.office_slug
                    )}
                    isShowcaseRace
                    tableHeader={CandidateRow.Header}
                    columnCount={CandidateRow.columnCount}
                    contestTitle={determineContestTitle(
                      data.filter(
                        item => item.office_slug === contest.office_slug
                      )[0]
                    )}
                    renderParty={party => (
                      <SeatPartyDivider
                        partyName={party.party}
                        partyBallot={party}
                        tableHeader={CandidateRow.Header}
                        notes={notes.filter(
                          item =>
                            item.type === contest.office_slug + '-' + party.party
                        )}
                        columnCount={CandidateRow.columnCount}
                        renderCandidate={(candidate, idx) => (
                          <CandidateRow
                            key={candidate.id}
                            ballotName={candidate.name}
                            candidateId={candidate.id}
                            isIncumbent={candidate.is_incumbent}
                            party={candidate.party}
                          />
                        )}
                      />
                    )}
                  />
                ))}
            </div>
          </Portal>
          <Portal
            node={document.querySelector('#agriculture-commissioner .contests')}
            ref={ref => (this._supremePortal = ref)}
          >
            <div class="office__contests">
              {unique_seats
                .filter(contest => contest.office === 'Agriculture Commissioner')
                .map(contest => (
                  <Contest
                    key={contest.id}
                    contest={data.filter(
                      item => item.office_slug === contest.office_slug
                    )}
                    notes={notes.filter(
                      item => item.type === contest.office_slug
                    )}
                    isShowcaseRace
                    tableHeader={CandidateRow.Header}
                    columnCount={CandidateRow.columnCount}
                    contestTitle={determineContestTitle(
                      data.filter(
                        item => item.office_slug === contest.office_slug
                      )[0]
                    )}
                    renderParty={party => (
                      <SeatPartyDivider
                        partyName={party.party}
                        partyBallot={party}
                        tableHeader={CandidateRow.Header}
                        notes={notes.filter(
                          item =>
                            item.type === contest.office_slug + '-' + party.party
                        )}
                        columnCount={CandidateRow.columnCount}
                        renderCandidate={(candidate, idx) => (
                          <CandidateRow
                            key={candidate.id}
                            ballotName={candidate.name}
                            candidateId={candidate.id}
                            isIncumbent={candidate.is_incumbent}
                            party={candidate.party}
                          />
                        )}
                      />
                    )}
                  />
                ))}
            </div>
          </Portal>
          <Portal
            node={document.querySelector('#us-senate .contests')}
            ref={ref => (this._supremePortal = ref)}
          >
            <div class="office__contests">
              {unique_seats
                .filter(contest => contest.office === 'U.S. Senate')
                .map(contest => (
                  <Contest
                    key={contest.id}
                    contest={data.filter(
                      item => item.office_slug === contest.office_slug
                    )}
                    notes={notes.filter(
                      item => item.type === contest.office_slug
                    )}
                    isShowcaseRace
                    tableHeader={CandidateRow.Header}
                    columnCount={CandidateRow.columnCount}
                    contestTitle={determineContestTitle(
                      data.filter(
                        item => item.office_slug === contest.office_slug
                      )[0]
                    )}
                    renderParty={party => (
                      <SeatPartyDivider
                        partyName={party.party}
                        partyBallot={party}
                        tableHeader={CandidateRow.Header}
                        notes={notes.filter(
                          item =>
                            item.type === contest.office_slug + '-' + party.party
                        )}
                        columnCount={CandidateRow.columnCount}
                        renderCandidate={(candidate, idx) => (
                          <CandidateRow
                            key={candidate.id}
                            ballotName={candidate.name}
                            candidateId={candidate.id}
                            isIncumbent={candidate.is_incumbent}
                            party={candidate.party}
                          />
                        )}
                      />
                    )}
                  />
                ))}
            </div>
          </Portal>
          <Portal
            node={document.querySelector('#railroad-commissioner .contests')}
            ref={ref => (this._supremePortal = ref)}
          >
            <div class="office__contests">
              {unique_seats
                .filter(contest => contest.office === 'Texas Railroad Commission')
                .map(contest => (
                  <Contest
                    key={contest.id}
                    contest={data.filter(
                      item => item.office_slug === contest.office_slug
                    )}
                    notes={notes.filter(
                      item => item.type === contest.office_slug
                    )}
                    tableHeader={CandidateRow.Header}
                    columnCount={CandidateRow.columnCount}
                    contestTitle={determineContestTitle(
                      data.filter(
                        item => item.office_slug === contest.office_slug
                      )[0]
                    )}
                    renderParty={party => (
                      <SeatPartyDivider
                        partyName={party.party}
                        partyBallot={party}
                        tableHeader={CandidateRow.Header}
                        notes={notes.filter(
                          item =>
                            item.type === contest.office_slug + '-' + party.party
                        )}
                        columnCount={CandidateRow.columnCount}
                        renderCandidate={(candidate, idx) => (
                          <CandidateRow
                            key={candidate.id}
                            ballotName={candidate.name}
                            candidateId={candidate.id}
                            isIncumbent={candidate.is_incumbent}
                            party={candidate.party}
                          />
                        )}
                      />
                    )}
                  />
                ))}
            </div>
          </Portal>
          <Portal
            node={document.querySelector('#state-board-of-education .contests')}
            ref={ref => (this._sboePortal = ref)}
          >
            <div class="office__contests">
              {unique_seats
                .filter(contest => contest.office === 'State Board of Education')
                .map(contest => (
                  <Contest
                    key={contest.id}
                    contest={data.filter(
                      item => item.office_slug === contest.office_slug
                    )}
                    notes={notes.filter(
                      item => item.type === contest.office_slug
                    )}
                    tableHeader={CandidateRow.Header}
                    columnCount={CandidateRow.columnCount}
                    contestTitle={determineContestTitle(
                      data.filter(
                        item => item.office_slug === contest.office_slug
                      )[0]
                    )}
                    renderParty={party => (
                      <SeatPartyDivider
                        partyName={party.party}
                        partyBallot={party}
                        tableHeader={CandidateRow.Header}
                        notes={notes.filter(
                          item =>
                            item.type === contest.office_slug + '-' + party.party
                        )}
                        columnCount={CandidateRow.columnCount}
                        renderCandidate={(candidate, idx) => (
                          <CandidateRow
                            key={candidate.id}
                            ballotName={candidate.name}
                            candidateId={candidate.id}
                            isIncumbent={candidate.is_incumbent}
                            party={candidate.party}
                          />
                        )}
                      />
                    )}
                  />
                ))}
            </div>
          </Portal>
          <Portal
            node={document.querySelector('#texas-supreme-court .contests')}
            ref={ref => (this._supremePortal = ref)}
          >
            <div class="office__contests">
              {unique_seats
                .filter(contest => contest.office === 'Texas Supreme Court')
                .map(contest => (
                  <Contest
                    key={contest.id}
                    contest={data.filter(
                      item => item.office_slug === contest.office_slug
                    )}
                    notes={notes.filter(
                      item => item.type === contest.office_slug
                    )}
                    tableHeader={CandidateRow.Header}
                    columnCount={CandidateRow.columnCount}
                    contestTitle={determineContestTitle(
                      data.filter(
                        item => item.office_slug === contest.office_slug
                      )[0]
                    )}
                    renderParty={party => (
                      <SeatPartyDivider
                        partyName={party.party}
                        partyBallot={party}
                        tableHeader={CandidateRow.Header}
                        notes={notes.filter(
                          item =>
                            item.type === contest.office_slug + '-' + party.party
                        )}
                        columnCount={CandidateRow.columnCount}
                        renderCandidate={(candidate, idx) => (
                          <CandidateRow
                            key={candidate.id}
                            ballotName={candidate.name}
                            candidateId={candidate.id}
                            isIncumbent={candidate.is_incumbent}
                            party={candidate.party}
                          />
                        )}
                      />
                    )}
                  />
                ))}
            </div>
          </Portal>
          <Portal
            node={document.querySelector(
              '#texas-court-of-criminal-appeals .contests'
            )}
            ref={ref => (this._crimPortal = ref)}
          >
            <div class="office__contests">
              {unique_seats
                .filter(
                  contest => contest.office === 'Texas Court of Criminal Appeals'
                )
                .map(contest => (
                  <Contest
                    key={contest.id}
                    contest={data.filter(
                      item => item.office_slug === contest.office_slug
                    )}
                    notes={notes.filter(
                      item => item.type === contest.office_slug
                    )}
                    tableHeader={CandidateRow.Header}
                    columnCount={CandidateRow.columnCount}
                    contestTitle={determineContestTitle(
                      data.filter(
                        item => item.office_slug === contest.office_slug
                      )[0]
                    )}
                    renderParty={party => (
                      <SeatPartyDivider
                        partyName={party.party}
                        partyBallot={party}
                        tableHeader={CandidateRow.Header}
                        notes={notes.filter(
                          item =>
                            item.type === contest.office_slug + '-' + party.party
                        )}
                        columnCount={CandidateRow.columnCount}
                        renderCandidate={(candidate, idx) => (
                          <CandidateRow
                            key={candidate.id}
                            ballotName={candidate.name}
                            candidateId={candidate.id}
                            isIncumbent={candidate.is_incumbent}
                            party={candidate.party}
                          />
                        )}
                      />
                    )}
                  />
                ))}
            </div>
          </Portal>
          <Portal
            node={document.querySelector('#texas-senate .contests')}
            ref={ref => (this._senatePortal = ref)}
          >
            <div class="office__contests">
              {unique_seats
                .filter(contest => contest.office === 'Texas Senate')
                .map(contest => (
                  <Contest
                    key={contest.id}
                    contest={data.filter(
                      item => item.office_slug === contest.office_slug
                    )}
                    notes={notes.filter(
                      item => item.type === contest.office_slug
                    )}
                    tableHeader={CandidateRow.Header}
                    columnCount={CandidateRow.columnCount}
                    contestTitle={determineContestTitle(
                      data.filter(
                        item => item.office_slug === contest.office_slug
                      )[0]
                    )}
                    renderParty={party => (
                      <SeatPartyDivider
                        partyName={party.party}
                        partyBallot={party}
                        tableHeader={CandidateRow.Header}
                        notes={notes.filter(
                          item =>
                            item.type === contest.office_slug + '-' + party.party
                        )}
                        columnCount={CandidateRow.columnCount}
                        renderCandidate={(candidate, idx) => (
                          <CandidateRow
                            key={candidate.id}
                            ballotName={candidate.name}
                            candidateId={candidate.id}
                            isIncumbent={candidate.is_incumbent}
                            party={candidate.party}
                          />
                        )}
                      />
                    )}
                  />
                ))}
            </div>
          </Portal>
  
          <Portal
            node={document.querySelector('#texas-house .contests')}
            ref={ref => (this._housePortal = ref)}
          >
            <div class="office__contests">
              {texasHouse.length > 0 &&
                texasHouseGroups.map(contestGroup => (
                  <div class="contest-group">
                    <div class="seat__contests-double">
                      {contestGroup.map(contest => (
                        <Contest
                          key={contest.id}
                          contest={data.filter(
                            item => item.office_slug === contest.office_slug
                          )}
                          notes={notes.filter(
                            item => item.type === contest.office_slug
                          )}
                          tableHeader={CandidateRow.Header}
                          columnCount={CandidateRow.columnCount}
                          contestTitle={determineContestTitle(
                            data.filter(
                              item => item.office_slug === contest.office_slug
                            )[0]
                          )}
                          renderParty={party => (
                            <SeatPartyDivider
                              partyName={party.party}
                              partyBallot={party}
                              tableHeader={CandidateRow.Header}
                              notes={notes.filter(
                                item =>
                                  item.type ===
                                  contest.office_slug + '-' + party.party
                              )}
                              columnCount={CandidateRow.columnCount}
                              renderCandidate={(candidate, idx) => (
                                <CandidateRow
                                  key={candidate.id}
                                  ballotName={candidate.name}
                                  candidateId={candidate.id}
                                  isIncumbent={candidate.is_incumbent}
                                  party={candidate.party}
                                />
                              )}
                            />
                          )}
                        />
                      ))}
                    </div>
                    <Ad />
                  </div>
                ))}
            </div>
          </Portal>
        </div>
      );
    }
  }
  
  export default App;